import { lowerCase, toNumber } from 'lodash';
import { nextActionIdsCompiler } from 'pages/Communications/ScenarioSetupPage/actionCompilers/utils/nextActionIdsCompiler';
import { StringUse } from 'lib/StringUse';
import { DateUse } from 'lib/DateUse';

export const waitCompiler = (action, filteredArrows) => {

    const {
        id,
        actionType,
        position,
        actionParams,
        settings: {
            values: {
                waitInterval,
                useTimeInterval
            },
            minDispatchTime,
            maxDispatchTime,
        }
    } = action;

    const nextActionIdsCompiled = nextActionIdsCompiler(filteredArrows, actionType);

    const utcMinDispatchTime = DateUse.convertLocalToUTC(minDispatchTime, 'HH:mm', 'HH:mm');
    const utcMaxDispatchTime = DateUse.convertLocalToUTC(maxDispatchTime, 'HH:mm', 'HH:mm');

    console.log('%cStart point:', 'color:orange', 'local:', minDispatchTime, 'utc:', utcMinDispatchTime);
    console.log('%cEnd point:', 'color:orange', 'local:', maxDispatchTime, 'utc:', utcMaxDispatchTime);


    return {
        action_id: id,
        action_type: lowerCase(actionType),
        action_params: actionParams,
        coordinates: position,
        action_options: {
            minutes_to_wait: toNumber(waitInterval.value),
            use_time_interval: useTimeInterval,
            ...(useTimeInterval && {
                time_to_send: {
                    to_time: StringUse.recast(utcMaxDispatchTime, { accepted: 'string', rejected: null }),
                    from_time: StringUse.recast(utcMinDispatchTime, { accepted: 'string', rejected: null }),
                },
            }),
        },
        next_actions_ids: [
            nextActionIdsCompiled
        ]
    }
}
